module.exports = __webpack_public_path__ + "img/bear_half.b6603500.svg";